import instance from './instance';

export const getToken = async ({ username, password }) => {
  try {
    const response = await instance.post('/login', {
      username,
      password,
    });
    return response.data.access_token;
  } catch (error) {
    console.error('Error fetching auth data:', error);
    throw error;
  }
};

export const verifyToken = async (token) => {
  try {
    const response = await instance.get('/verify', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error verifying token:', error);
    throw error;
  }
};

export const signup = async ({ username, password }) => {
  try {
    const response = await instance.post('/signup', {
      username,
      password,
    });
    return response.data;
  } catch (error) {
    console.error('Error during signup:', error);
    throw error;
  }
};
